// In contactUsFormSubmit.ts (or your server action file)

"use server";

import { ServerActionResponse } from "@/src/common-types";
import nodemailer from "nodemailer";
import { ContactUsSchemaType } from "..";
import axios from "axios";

interface ExtendedContactUsSchemaType extends ContactUsSchemaType {
  recaptchaToken: string;
}

async function verifyRecaptcha(token: string): Promise<boolean> {
  const secretKey = process.env.RECAPTCHA_SECRET_KEY;
  const verificationUrl = `https://www.google.com/recaptcha/api/siteverify?secret=${secretKey}&response=${token}`;

  try {
    const response = await axios.post(verificationUrl);
    return response.data.success;
  } catch (error) {
    console.error("reCAPTCHA verification failed:", error);
    return false;
  }
}

export async function contactUsFormSubmit(
  values: ExtendedContactUsSchemaType
): Promise<ServerActionResponse<boolean>> {
  const { name, email, subject, message, recaptchaToken } = values;

  // Verify reCAPTCHA
  const isRecaptchaValid = await verifyRecaptcha(recaptchaToken);
  if (!isRecaptchaValid) {
    return {
      isSuccess: false,
      data: null,
      message: "reCAPTCHA verification failed",
    };
  }

  try {
    const transporter = nodemailer.createTransport({
      service: "gmail",
      auth: {
        user: process.env.SENDER_EMAIL,
        pass: process.env.SENDER_TOEKN,
      },
    });

    const mailOptions = {
      from: email,
      to: process.env.CONTACT_EMAIL,
      subject: subject,
      html: `
        <h3 style="margin-bottom:8px">Name:</h3>
        <p style="margin:0">${name}</p>
        <br/>
        <h3 style="margin:0; margin-bottom:8px">Email:</h3>
        <p style="margin:0">${email}</p>
        <br/>
        <h3 style="margin:0; margin-bottom:8px">Body:</h3>
        <p style="margin-top:0">${message}</p>
      `,
    };

    await transporter.sendMail(mailOptions);

    return {
      isSuccess: true,
      data: true,
      message: "Thank you for contacting us.",
    };
  } catch (error) {
    console.error(error);
    return {
      isSuccess: false,
      data: null,
      message: "Internal Server Error",
    };
  }
}
